/**
 * DomainReadiness — % per GTM domain (Core Intelligence, Product Experience, ...).
 *
 * All percentages CALCULATED via the shared client-side progress module.
 */
import { domainReadiness, DOMAIN_TITLES, DOMAIN_ORDER } from "./progressCalc";

export default function DomainReadinessPanel({ milestones }) {
    const dr = domainReadiness(milestones);
    const rows = DOMAIN_ORDER.map((d) => ({ d, pct: Math.round((dr[d] ?? 0) * 100) }));
    return (
        <div data-testid="gtm-domain-readiness" className="qoryn-panel rounded-2xl p-5">
            <div className="flex items-center justify-between mb-4">
                <h3 className="font-display text-[15px] text-qoryn-text tracking-tight">GTM Readiness · Domains</h3>
                <span className="font-mono-ui text-[9px] tracking-widest uppercase text-qoryn-textMuted">
                    Calculated
                </span>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {rows.map(({ d, pct }) => (
                    <div key={d} data-testid={`gtm-domain-${d}`} className="rounded-xl border border-qoryn-border/60 bg-black/25 p-3">
                        <div className="font-mono-ui text-[9px] tracking-widest uppercase text-qoryn-textDim">
                            {DOMAIN_TITLES[d] ?? d}
                        </div>
                        <div className="flex items-baseline gap-1 mt-1">
                            <span className="font-display text-[24px] leading-none text-qoryn-text tracking-tight">
                                {pct}
                            </span>
                            <span className="font-display text-[14px] text-qoryn-textDim">%</span>
                        </div>
                        <div className="mt-2 h-1 rounded-full bg-white/[0.05] overflow-hidden">
                            <div className="h-full bg-qoryn-cyan/60 transition-[width] duration-500 ease-out" style={{ width: `${pct}%` }} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
